<template>
  <section class="bg-bgr py-6">
    <div class="mb-5" :class="contentWidthClass">
      <slot />
    </div>

    <div class="mb-12" :class="contentWidthClass">
      <slot name="searchteaser" />
    </div>

    <div class="mb-12" :class="contentWidthClass">
      <SearchTeaserFilters :search-facets />
      <TeaserSubDestinations :destination="confData.destination" />
      <slot name="contentassets" />
    </div>

    <div v-if="additionalBody.seotext.content_html" :class="contentWidthClass">
      <WebccExpandable :key="additionalBody.seotext.content_html">
        <div v-impression:search:seoTextImpression.100="'start'"></div>
        <article
          class="prose prose-richtext-searchpage mt-4 max-w-none prose-img:w-full"
          @click.prevent="onSeoTextClick"
          v-html="additionalBody.seotext.content_html"
        ></article>
        <div v-impression:search:seoTextImpression.100="'end'"></div>
      </WebccExpandable>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  searchFacets?: SearchApiFacets
}>()

const confData = useConfdata()

const { contentWidthClass } = useContentWidth()
const { handleClick } = useSeoText()

const additionalBody = computed(
  () => useConfdata().additionalBody as SearchPageBody,
)

function onSeoTextClick(event: MouseEvent) {
  handleClick(event, { external: true })
}
</script>
